/**
 * Colapsa listas de la descripción del producto (Incluye / Limitaciones)
 * mostrando solo N puntos y un botón «Ver más / Ver menos».
 */
(function () {
  if (document.documentElement.dataset.productDescCollapseInit === 'true') return;
  document.documentElement.dataset.productDescCollapseInit = 'true';

  const VISIBLE_ITEMS = 2;
  const CARD_VISIBLE_ITEMS = 3;
  const SECTION_RE = /incluye|limitaciones/i;

  function productDetailsRoot() {
    return (
      document.querySelector('.product-information .product-details') ||
      document.querySelector('.product-information')
    );
  }

  function isSectionHeading(el) {
    if (!(el instanceof HTMLElement)) return false;
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > 80) return false;
    return SECTION_RE.test(text);
  }

  function findFollowingList(heading) {
    let node = heading.nextElementSibling;
    while (node) {
      if (node instanceof HTMLUListElement || node instanceof HTMLOListElement) {
        return node;
      }
      if (isSectionHeading(node)) break;
      const nested = node.querySelector?.('ul, ol');
      if (nested instanceof HTMLUListElement || nested instanceof HTMLOListElement) {
        return nested;
      }
      node = node.nextElementSibling;
    }
    return null;
  }

  function collapseList(list) {
    if (!(list instanceof HTMLElement) || list.dataset.horusDescCollapse === 'true') return;

    const items = Array.from(list.children).filter(
      (el) => el instanceof HTMLLIElement,
    );
    if (items.length <= VISIBLE_ITEMS) return;

    list.dataset.horusDescCollapse = 'true';
    const hidden = items.slice(VISIBLE_ITEMS);
    for (const item of hidden) {
      item.hidden = true;
      item.dataset.horusDescCollapsedItem = 'true';
    }

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'horus-desc-collapse__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.dataset.horusDescToggle = 'true';
    btn.textContent = 'Ver más';

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      btn.textContent = next ? 'Ver menos' : 'Ver más';
      for (const item of hidden) {
        item.hidden = !next;
      }
    });

    list.insertAdjacentElement('afterend', btn);
  }

  function enhance() {
    const root = productDetailsRoot();
    if (!root) return;

    const candidates = root.querySelectorAll(
      '.rte p, .rte h2, .rte h3, .rte h4, .rte strong, .rte b, [class*="rte"] p, [class*="rte"] h2, [class*="rte"] h3, [class*="rte"] strong',
    );

    const headings = new Set();
    for (const el of candidates) {
      if (!isSectionHeading(el)) continue;
      // Prefer the block-level ancestor when the match is a nested strong/b
      const block =
        el.closest('p, h2, h3, h4, h5, h6') instanceof HTMLElement
          ? el.closest('p, h2, h3, h4, h5, h6')
          : el;
      if (block) headings.add(block);
    }

    // Fallback: walk direct children of rte containers
    if (headings.size === 0) {
      for (const rte of root.querySelectorAll('.rte, [class*="rte"], .text-block')) {
        for (const child of rte.children) {
          if (isSectionHeading(child)) headings.add(child);
        }
      }
    }

    for (const heading of headings) {
      const list = findFollowingList(heading);
      if (list) collapseList(list);
    }
  }

  function trimCardList(list) {
    if (!(list instanceof HTMLElement) || list.dataset.horusCardTrim === 'true') return;

    const items = Array.from(list.children).filter((el) => el instanceof HTMLLIElement);
    if (items.length <= CARD_VISIBLE_ITEMS) return;

    list.dataset.horusCardTrim = 'true';
    const hidden = items.slice(CARD_VISIBLE_ITEMS);
    for (const item of hidden) {
      item.hidden = true;
    }

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'horus-desc-collapse__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Ver más';
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      btn.textContent = next ? 'Ver menos' : 'Ver más';
      for (const item of hidden) {
        item.hidden = !next;
      }
    });
    list.insertAdjacentElement('afterend', btn);
  }

  function enhanceCards() {
    const cards = document.querySelectorAll(
      '.section-resource-list .product-card, .product-list--tier-medals .product-card, .product-list--center-cards .product-card',
    );
    for (const card of cards) {
      const lists = card.querySelectorAll('ul, ol');
      for (const list of lists) {
        trimCardList(list);
      }
    }
  }

  function init() {
    enhance();
    enhanceCards();
    window.setTimeout(enhance, 400);
    window.setTimeout(enhanceCards, 400);
    window.setTimeout(enhance, 1200);
    window.setTimeout(enhanceCards, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
